// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const OrdersLoader = Loadable({
  loader: () => import('./OrdersContainer'),
  loading: Loader,
})

export default OrdersLoader
